import { useMutation, useQueryClient } from '@tanstack/react-query'
import { subscribeToElite } from '../repository/peer-analyser'
import { usePeerAnalyserStore } from '../state-management/peerAnalyserStore'

// The React Query useMutation hook
export const useSubscribeToEliteMutation = () => {
  const selectedCategoryId = usePeerAnalyserStore((state) => state.selectedCategoryId)
  const fundNature = usePeerAnalyserStore((state) => state.fundNature)
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: subscribeToElite,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['peerAnalyserFunds'], exact: false })
      queryClient.invalidateQueries({ queryKey: ['browseCategories'], exact: false })
    },
    onError: (error) => {
      // Optional: Handle errors globally or log them
      console.error('Subscription failed:', error)
    }
  })
}
